import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listConfig, updateConfig as _updateConfig, getLog } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import eleDialog from "./components/eleDialog.vue";
export default {
  name: "",
  props: ['deviceSn', 'deviceDid'],
  components: {
    eleDialog: eleDialog
  },
  data: function data() {
    var _this = this;

    var validateUpdateInterval = function validateUpdateInterval(rule, value, callback) {
      if (value < 3) {
        callback(new Error(_this.$t('lang.smartele.updateInterval')));
      } else {
        callback();
      }
    };

    var validateLog_file_num = function validateLog_file_num(rule, value, callback) {
      if (value < 0) {
        callback(new Error(_this.$t('lang.smartele.log_file_num')));
      } else {
        callback();
      }
    };

    var validateLog_file_size = function validateLog_file_size(rule, value, callback) {
      if (value < 0) {
        callback(new Error(_this.$t('lang.smartele.log_file_size')));
      } else {
        callback();
      }
    }; // 气压在100-500之间且只可以为数字


    var validatePressure = function validatePressure(rule, value, callback) {
      if (value < 100 || value > 500) {
        callback(new Error(_this.$t('lang.smartele.errorMsg')));
      } else {
        callback();
      }
    }; // 浮动值在0.0001 ~ 0.001之间


    var validateFloat = function validateFloat(rule, value, callback) {
      if (value < 0.0001 || value > 0.001) {
        callback(new Error(_this.$t('lang.smartele.errorMsg')));
      } else {
        callback();
      }
    }; // 浮动测试在2 ~ 10之间


    var validateFloatTest = function validateFloatTest(rule, value, callback) {
      if (value < 2 || value > 10) {
        callback(new Error(_this.$t('lang.smartele.errorMsg')));
      } else {
        callback();
      }
    };

    return {
      activeName: "default",
      server: {
        enabled: false,
        server: [""],
        mqtt_cid: '',
        username: '',
        password: '',
        topic_sub: '',
        topic_pub: '',
        mqtt_qos: '2',
        mqtt_alive: '',
        clean_session: '',
        retain: '',
        status: 'connected'
      },
      senior: {
        enabled: false,
        enable_debug: false,
        updateInterval: '0',
        log_file_num: '0',
        log_file_size: '0',
        log_priority: '0'
      },
      loading: true,
      LogPriorityList: [{
        value: '8',
        label: this.$t('lang.smartlink.debug')
      }, {
        value: '7',
        label: this.$t('lang.smartlink.info')
      }, {
        value: '6',
        label: this.$t('lang.smartlink.notice')
      }, {
        value: '5',
        label: this.$t('lang.smartlink.alarm')
      }, {
        value: '4',
        label: this.$t('lang.smartlink.error')
      }, {
        value: '3',
        label: this.$t('lang.smartlink.deadly')
      }, {
        value: '2',
        label: this.$t('lang.smartlink.alert')
      }, {
        value: '1',
        label: this.$t('lang.smartlink.emergency')
      }],
      seniorRule: {
        // updateInterval必填并且大于3
        updateInterval: [{
          required: true,
          message: this.$t('lang.smartele.updateInterval'),
          trigger: 'blur'
        }, {
          validator: validateUpdateInterval,
          trigger: 'blur'
        }],
        // log_file_num必填且大于0
        log_file_num: [{
          required: true,
          message: this.$t('lang.smartele.log_file_num'),
          trigger: 'blur'
        }, {
          validator: validateLog_file_num,
          trigger: 'blur'
        }],
        // log_file_size必填且大于0
        log_file_size: [{
          required: true,
          message: this.$t('lang.smartele.log_file_size'),
          trigger: 'blur'
        }, {
          validator: validateLog_file_size,
          trigger: 'blur'
        }]
      },
      report: {
        reportStrategy: '1',
        reportType: '1',
        reportInterval: '1',
        reportRateUpper: '1',
        reportRateLower: '24'
      },
      speed: {
        velCfg1: '1',
        velCfg2: '1',
        velCfg3: '10'
      },
      acceleration: {
        aspect: '1',
        accCfg1: '1',
        accCfg2: '1',
        accCfg3: '10'
      },
      pressure: {
        pressCfg1: '1',
        pressCfg2: '1',
        pressCfg3: '10',
        axisInter: '1',
        subPress: '1',
        pressCount: '1'
      },
      height: {
        heightCfg1: '1',
        heightCfg2: '1',
        heightCfg3: '10'
      },
      temp: {
        tempCfg1: '1',
        tempCfg2: '1',
        tempCfg3: '10'
      },
      humidity: {
        humCfg1: '1',
        humCfg2: '1',
        humCfg3: '10'
      },
      direction: {
        dirCfg1: '10',
        dirCfg2: '10'
      },
      door: {
        doorCfg1: '10',
        doorCfg2: '10'
      },
      floor: {
        lvCfg1: '10',
        lvCfg2: '10'
      },
      base: {
        blvCfg1: '10',
        blvCfg2: '10'
      },
      person: {
        personCfg1: '10',
        personCfg2: '10'
      },
      serialData: [],
      pressureRules: {
        axisInter: [{
          required: true,
          message: this.$t('lang.smartele.errorMsg'),
          trigger: 'blur'
        }, {
          validator: validatePressure,
          trigger: 'blur'
        }],
        // 浮动
        subPress: [{
          required: true,
          message: this.$t('lang.smartele.errorMsg'),
          trigger: 'blur'
        }, {
          validator: validateFloat,
          trigger: 'blur'
        }],
        // 浮动次数
        pressCount: [{
          required: true,
          message: this.$t('lang.smartele.errorMsg'),
          trigger: 'blur'
        }, {
          validator: validateFloatTest,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getConfig();

            case 2:
              _context.next = 4;
              return this.getSeniorConfig();

            case 4:
              this.loading = false;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    // 获取配置
    getConfig: function getConfig() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        listConfig(_this2.deviceSn, _this2.deviceDid, [{
          config: 'smartele',
          section: 'CLOUD',
          options: [{
            option: 'enabled'
          }, {
            option: 'mqtt_cid'
          }, {
            option: 'username'
          }, {
            option: 'password'
          }, {
            option: 'topic_sub'
          }, {
            option: 'topic_pub'
          }, {
            option: 'mqtt_qos'
          }, {
            option: 'mqtt_alive'
          }, {
            option: 'clean_session'
          }, {
            option: 'retain'
          }, {
            option: 'status'
          }],
          lists: [{
            list: 'server'
          }]
        }, {
          config: 'smartele',
          section: 'policy',
          options: [{
            option: 'reportStrategy'
          }, {
            option: 'reportType'
          }, {
            option: 'reportInterval'
          }, {
            option: 'reportRateUpper'
          }, {
            option: 'reportRateLower'
          }, {
            option: 'velCfg1'
          }, {
            option: 'velCfg2'
          }, {
            option: 'velCfg3'
          }, {
            option: 'aspect'
          }, {
            option: 'accCfg1'
          }, {
            option: 'accCfg2'
          }, {
            option: 'accCfg3'
          }, {
            option: 'pressCfg1'
          }, {
            option: 'pressCfg2'
          }, {
            option: 'pressCfg3'
          }, {
            option: 'axisInter'
          }, {
            option: 'subPress'
          }, {
            option: 'pressCount'
          }, {
            option: 'heightCfg1'
          }, {
            option: 'heightCfg2'
          }, {
            option: 'heightCfg3'
          }, {
            option: 'tempCfg1'
          }, {
            option: 'tempCfg2'
          }, {
            option: 'tempCfg3'
          }, {
            option: 'humCfg1'
          }, {
            option: 'humCfg2'
          }, {
            option: 'humCfg3'
          }, {
            option: 'dirCfg1'
          }, {
            option: 'dirCfg2'
          }, {
            option: 'doorCfg1'
          }, {
            option: 'doorCfg2'
          }, {
            option: 'lvCfg1'
          }, {
            option: 'lvCfg2'
          }, {
            option: 'blvCfg1'
          }, {
            option: 'blvCfg2'
          }, {
            option: 'personCfg1'
          }, {
            option: 'personCfg2'
          }]
        }, {
          config: 'smartele',
          section: 'serial',
          options: [{
            option: 'baudrate'
          }, {
            option: 'data_bits'
          }, {
            option: 'stop_bits'
          }, {
            option: 'parity'
          }, {
            option: 'flow_ctrl'
          }, {
            option: 'enable_frame'
          }, {
            option: 'timeout'
          }, {
            option: 'frame_len'
          }]
        }]).then(function (res) {
          var options = res.data.data.mess[0].s_objects[0].options;
          _this2.server.enabled = options.enabled === '1' ? true : false;
          _this2.server.mqtt_cid = options.mqtt_cid;
          _this2.server.username = options.username;
          _this2.server.password = options.password;
          _this2.server.topic_sub = options.topic_sub;
          _this2.server.topic_pub = options.topic_pub;
          _this2.server.mqtt_qos = options.mqtt_qos;
          _this2.server.mqtt_alive = options.mqtt_alive;
          _this2.server.clean_session = options.clean_session === '1' ? true : false;
          _this2.server.retain = options.retain === '1' ? true : false;
          _this2.server.status = options.status;
          _this2.server.server = res.data.data.mess[0].s_objects[0].lists.server;
          var options2 = res.data.data.mess[1].s_objects[0].options;
          _this2.report.reportStrategy = options2.reportStrategy;
          _this2.report.reportType = options2.reportType;
          _this2.report.reportInterval = options2.reportInterval;
          _this2.report.reportRateUpper = options2.reportRateUpper;
          _this2.report.reportRateLower = options2.reportRateLower;
          _this2.speed.velCfg1 = options2.velCfg1;
          _this2.speed.velCfg2 = options2.velCfg2;
          _this2.speed.velCfg3 = options2.velCfg3;
          _this2.acceleration.aspect = options2.aspect;
          _this2.acceleration.accCfg1 = options2.accCfg1;
          _this2.acceleration.accCfg2 = options2.accCfg2;
          _this2.acceleration.accCfg3 = options2.accCfg3;
          _this2.pressure.pressCfg1 = options2.pressCfg1;
          _this2.pressure.pressCfg2 = options2.pressCfg2;
          _this2.pressure.pressCfg3 = options2.pressCfg3;
          _this2.pressure.axisInter = options2.axisInter;
          _this2.pressure.subPress = options2.subPress;
          _this2.pressure.pressCount = options2.pressCount;
          _this2.height.heightCfg1 = options2.heightCfg1;
          _this2.height.heightCfg2 = options2.heightCfg2;
          _this2.height.heightCfg3 = options2.heightCfg3;
          _this2.temp.tempCfg1 = options2.tempCfg1;
          _this2.temp.tempCfg2 = options2.tempCfg2;
          _this2.temp.tempCfg3 = options2.tempCfg3;
          _this2.humidity.humCfg1 = options2.humCfg1;
          _this2.humidity.humCfg2 = options2.humCfg2;
          _this2.humidity.humCfg3 = options2.humCfg3;
          _this2.direction.dirCfg1 = options2.dirCfg1;
          _this2.direction.dirCfg2 = options2.dirCfg2;
          _this2.door.doorCfg1 = options2.doorCfg1;
          _this2.door.doorCfg2 = options2.doorCfg2;
          _this2.floor.lvCfg1 = options2.lvCfg1;
          _this2.floor.lvCfg2 = options2.lvCfg2;
          _this2.base.blvCfg1 = options2.blvCfg1;
          _this2.base.blvCfg2 = options2.blvCfg2;
          _this2.person.personCfg1 = options2.personCfg1;
          _this2.person.personCfg2 = options2.personCfg2;
          var options3 = res.data.data.mess[2].s_objects;
          options3.forEach(function (v) {
            _this2.serialData.push({
              baudrate: v.options.baudrate,
              data_bits: v.options.data_bits,
              stop_bits: v.options.stop_bits,
              parity: v.options.parity,
              flow_ctrl: v.options.flow_ctrl,
              name: v.sname,
              enable_frame: v.options.enable_frame == '1' ? true : false,
              timeout: v.options.timeout,
              frame_len: v.options.frame_len,
              parity_value: _this2.keyValue(v.options.parity),
              flow_ctrl_value: _this2.keyValue(v.options.flow_ctrl)
            });
          });
          resolve();
        });
      });
    },
    keyValue: function keyValue(e) {
      switch (e) {
        case 'N':
          return 'None';

        case 'S':
          return 'Space';

        case 'E':
          return 'Even';

        case 'M':
          return 'Mark';

        case 'O':
          return 'Odd';

        case 'X':
          return 'XON/XOFF';
      }
    },
    // 更新配置
    updateConfig: function () {
      var _updateConfig2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var server;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loading = true;
                server = this.server.server.map(function (v) {
                  return v.trim();
                }).filter(function (v) {
                  return v !== '';
                });
                _context2.next = 4;
                return _updateConfig(this.deviceSn, this.deviceDid, [{
                  config: 'smartele',
                  section: 'CLOUD',
                  action: 0,
                  index: [0],
                  options: {
                    enabled: this.server.enabled ? '1' : '0',
                    mqtt_cid: this.server.mqtt_cid,
                    username: this.server.username,
                    password: this.server.password,
                    topic_sub: this.server.topic_sub,
                    topic_pub: this.server.topic_pub,
                    mqtt_qos: this.server.mqtt_qos,
                    mqtt_alive: this.server.mqtt_alive,
                    clean_session: this.server.clean_session ? '1' : '0',
                    retain: this.server.retain ? '1' : '0'
                  },
                  lists: {
                    server: server
                  }
                }, {
                  config: 'smartele',
                  section: 'policy',
                  action: 0,
                  index: [0],
                  options: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.report), this.speed), this.acceleration), this.pressure), this.height), this.temp), this.humidity), this.direction), this.door), this.floor), this.base), this.person)
                }]);

              case 4:
                _context2.next = 6;
                return _updateConfig(this.deviceSn, this.deviceDid, [{
                  config: 'smartele',
                  section: 'service',
                  action: 0,
                  index: [0],
                  options: {
                    enabled: this.senior.enabled ? '1' : '0',
                    enable_debug: this.senior.enable_debug ? '1' : '0',
                    updateInterval: this.senior.updateInterval,
                    log_file_num: this.senior.log_file_num,
                    log_file_size: this.senior.log_file_size,
                    log_priority: this.senior.log_priority
                  }
                }]).then(function (res) {
                  progressControl([{
                    process: "smartele",
                    action: "restart",
                    type: 0
                  }], String(_this3.deviceDid), _this3.deviceSn).then(function (res) {
                    _this3.$message({
                      message: '更新成功',
                      type: 'success'
                    });

                    _this3.getSeniorConfig().then(function () {
                      _this3.loading = false;
                    });
                  });
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateConfig() {
        return _updateConfig2.apply(this, arguments);
      }

      return updateConfig;
    }(),
    // 刷新
    refsh: function () {
      var _refsh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loading = true;
                _context3.next = 3;
                return this.getSeniorConfig();

              case 3:
                this.getConfig().then(function () {
                  _this4.loading = false;
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function refsh() {
        return _refsh.apply(this, arguments);
      }

      return refsh;
    }(),
    getSeniorConfig: function getSeniorConfig() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        listConfig(_this5.deviceSn, _this5.deviceDid, [{
          config: 'smartele',
          section: 'service',
          options: [{
            option: 'enabled'
          }, {
            option: 'enable_debug'
          }, {
            option: 'updateInterval'
          }, {
            option: 'log_file_num'
          }, {
            option: 'log_file_size'
          }, {
            option: 'log_priority'
          }]
        }]).then(function (res) {
          var options = res.data.data.mess[0].s_objects[0].options;
          _this5.senior.enabled = options.enabled === '1' ? true : false;
          _this5.senior.enable_debug = options.enable_debug === '1' ? true : false;
          _this5.senior.updateInterval = options.updateInterval;
          _this5.senior.log_file_num = options.log_file_num;
          _this5.senior.log_file_size = options.log_file_size;
          _this5.senior.log_priority = options.log_priority;
          resolve();
        });
      });
    },
    downloadFile: function downloadFile() {
      var params = {
        did: this.deviceDid,
        sn: this.deviceSn,
        mess: "smartele"
      };
      getLog(params).then(function (res) {
        var blob = new Blob([res.data], {
          type: 'application/octet-stream'
        });
        var fileName = 'log.txt';

        if ('download' in document.createElement('a')) {
          // 非IE下载
          var elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象

          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    editSerial: function editSerial(e) {
      this.$refs.eledialog.show(e);
    }
  }
};